import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC, useCallback } from 'react';
import { useInfinityScroll } from 'react-utils';
import { makeStyles } from 'tss-react/mui';
import { useSnapshot } from 'valtio';
import OxDataGrid from '../../elements/OxDataGrid/OxDataGrid';
import { loadAuditLogs } from '../actions/audit-logs-actions';
import config from '../config/audit-log-config.json';
import { useAuditLogsHeader } from '../hooks/use-audit-logs-header';
import { setSelectedLog } from '../store-actions/audit-logs-store-actions';
import AuditLogsStore from '../stores/audit-logs-store';

const AuditLogsTable: FC = () => {
  const { classes } = useStyles();
  const { auditLogs, loading, selectedAuditLogId } =
    useSnapshot(AuditLogsStore);

  const columns = useAuditLogsHeader(classes);
  const { onScroll } = useInfinityScroll({
    load: loadAuditLogs,
    threshold: 0.9,
  });

  const onRowClick = useCallback((row: AuditLog) => {
    setSelectedLog(row);
  }, []);

  return (
    <div className={classes.tableContainer}>
      <OxDataGrid
        onRowClick={onRowClick}
        activeRowKey='id'
        activeRowValue={selectedAuditLogId}
        rowHeight={config.table.rowHeight}
        onScroll={onScroll}
        columns={columns}
        rows={auditLogs}
        loading={loading.isPending()}
      />
    </div>
  );
};

const useStyles = makeStyles()({
  tableContainer: {
    borderRadius: 10,
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  headerCell: {
    textAlign: 'center',
    '& .rdg-header-sort-name': {
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
      lineHeight: 1,
      alignSelf: 'center',
      fontSize: 10,
    },
  },
});

export default AuditLogsTable;
